import { FC, useState } from "react";
import { useLocation } from "react-router-dom";
import ForgotPassword from "@features/auth/forgotPassword/ForgotPassword";
import VerifyOtp from "@features/auth/verifyOtp/VerifyOtp";
import BackToLogin from "@features/common/backToLogin/BackToLogin";

// ============================================================================
// Component
// ============================================================================

const ForgotPasswordPage: FC = () => {
  const location = useLocation();
  const [showOtpVerification, setShowOtpVerification] = useState(false);
  const [otpUrls, setOtpUrls] = useState<any>(null);
  const params = new URLSearchParams(location.search);
  const emailFromUrl = params.get("email") ?? "";

  const handleEmailVerified = () => {
    setShowOtpVerification(true);
  };

  return (
    <>
      {/* Back to Login navigation link */}
      <BackToLogin />

      {showOtpVerification ? (
        // Step 2: OTP Verification & Password Reset
        <VerifyOtp
          isForgotPassword={true}
          otpUrls={otpUrls}
          verifiedEmail={emailFromUrl}
        />
      ) : (
        // Step 1: Email Verification & OTP Request
        <ForgotPassword
          onEmailIdVerified={handleEmailVerified}
          setOtpUrls={setOtpUrls}
        />
      )}
    </>
  );
};

export default ForgotPasswordPage;
